// Tekst-hulpjes voor velden die platte tekst horen te zijn.

const ENTITEITEN: Record<string, string> = {
  "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"',
  "&#39;": "'", "&apos;": "'", "&nbsp;": " ", "&euro;": "€",
};

/**
 * Haalt HTML-opmaak uit een tekst.
 *
 * De korte omschrijving is platte tekst: hij wordt getoond als lopende zin op de
 * productpagina én gebruikt als SEO-meta-omschrijving en in de productfeed. Staat
 * er HTML in (zoals uit een importbestand), dan ziet de bezoeker letterlijk
 * "<p>" staan en krijgt Google een meta-omschrijving vol tags.
 *
 * Blokelementen worden een spatie zodat woorden niet aan elkaar plakken;
 * <br> wordt een spatie in plaats van te verdwijnen.
 */
export function stripHtml(input: unknown): string {
  if (input == null) return "";
  let s = String(input);
  if (!s.includes("<") && !s.includes("&")) return s.trim();

  s = s.replace(/<\s*(br|\/p|\/div|\/li|\/h[1-6])\s*\/?>/gi, " ");
  s = s.replace(/<[^>]*>/g, "");
  s = s.replace(/&[a-z#0-9]+;/gi, (m) => ENTITEITEN[m.toLowerCase()] ?? m);
  return s.replace(/\s+/g, " ").trim();
}

/**
 * Serialiseert data voor een `<script type="application/ld+json">`-tag.
 *
 * `JSON.stringify` escaped geen `<` of `/`, dus een veldwaarde met een
 * letterlijke `</script>`-substring (bv. een klantreview of productnaam)
 * sluit de scripttag vroegtijdig af en breekt uit als los, uitvoerbaar
 * HTML/script-element — ongeacht dat de waarde "binnen" een JSON-string
 * zit. `<` is een geldige JSON-escape voor `<` en wordt door de
 * JSON-parser weer teruggelezen als het gewone teken, dus dit verandert
 * de data niet — het voorkomt alleen de HTML-parser-uitbraak.
 */
export function safeJsonLdString(data: unknown): string {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}

/** Escaped tekst voor gebruik binnen HTML (bv. formuliervelden in een e-mail-body). */
export function escapeHtml(input: unknown): string {
  return String(input ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
